<!-- App.vue -->
<template>
  <Home />
</template>

<script>
import Home from "./views/Home.vue";

export default {
  name: "App",
  components: {
    Home,
  },
};
</script>

<style>
/* Optionally add global styles here */
</style>
